import ConsultationBhScheduleViewController from "./consultation-bh-schedule-view-controller";

class MessageCenterBhScheduleViewController extends ConsultationBhScheduleViewController {
  handleButtonClick(name, text, action) {
    super.handleButtonClick(name, text, action, 3);
  }
}

export default MessageCenterBhScheduleViewController;
